import { CountResponse } from '@interfaces/common.interface';
import {
  CountMedicalOrganizationsRequestParams,
  CreateMedicalOrganizationRequest,
  GetMedicalOrganizationsRequestParams,
  MedicalOrganization,
  UpdateMedicalOrganizationRequest,
} from '@interfaces/medicalOrganizations.interface';

import api from './';

export const {
  useGetMedicalOrganizationByIdQuery,
  useCountMedicalOrganizationsQuery,
  useGetManyMedicalOrganizationsQuery,
  useCreateMedicalOrganizationMutation,
  useUpdateMedicalOrganizationMutation,
  useDeleteMedicalOrganizationMutation,
} = api.injectEndpoints({
  endpoints: (build) => ({
    getMedicalOrganizationById: build.query<MedicalOrganization, string>({
      query: (id) => ({ url: `medical-organizations/${id}` }),
      providesTags: ['medicalOrganizations'],
    }),
    countMedicalOrganizations: build.query<
      CountResponse,
      CountMedicalOrganizationsRequestParams
    >({
      query: (params) => ({ url: 'medical-organizations/count', params }),
      providesTags: ['medicalOrganizations'],
    }),
    getManyMedicalOrganizations: build.query<
      MedicalOrganization[],
      GetMedicalOrganizationsRequestParams
    >({
      query: (params) => ({ url: 'medical-organizations', params }),
      providesTags: ['medicalOrganizations'],
    }),
    createMedicalOrganization: build.mutation<
      MedicalOrganization,
      CreateMedicalOrganizationRequest
    >({
      query: (body) => ({
        url: 'medical-organizations',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['medicalOrganizations', 'users'],
    }),
    updateMedicalOrganization: build.mutation<
      MedicalOrganization,
      UpdateMedicalOrganizationRequest
    >({
      query: ({ id, body }) => ({
        url: `medical-organizations/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['medicalOrganizations', 'users'],
    }),
    deleteMedicalOrganization: build.mutation<MedicalOrganization, string>({
      query: (id) => ({
        url: `medical-organizations/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['medicalOrganizations', 'users'],
    }),
  }),
});
